import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const { t } = useTranslation();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    try {
      const body = new URLSearchParams();
      body.append('email', email);
      const res = await fetch('https://readdy.ai/api/form/d7ch39c5q56ra7tuf6u0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="bg-[#0d0d0d] py-24 px-6">
      <div className="max-w-xl mx-auto text-center">
        <p className="text-amber-400/60 text-xs tracking-[0.3em] uppercase mb-4 font-light">{t('newsletter_label')}</p>
        <h2
          className="text-3xl md:text-4xl font-light text-white mb-4"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {t('newsletter_title')}
        </h2>
        <p className="text-white/40 text-sm mb-10 font-light">
          {t('newsletter_subtitle')}
        </p>

        {status === 'success' ? (
          <div className="border border-amber-700/40 rounded-lg px-8 py-6 text-amber-400/80 text-sm">
            {t('newsletter_success')}
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder={t('newsletter_placeholder')}
              required
              className="flex-1 bg-white/5 border border-white/15 text-white text-sm placeholder-white/30 rounded-md px-5 py-3 focus:outline-none focus:border-amber-600/50 transition-colors"
            />
            <button
              type="submit"
              className="bg-[#c9a84c] hover:bg-[#b8963e] text-[#1a0f00] text-xs tracking-widest uppercase font-semibold px-7 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('newsletter_btn')}
            </button>
          </form>
        )}
        {status === 'error' && (
          <p className="text-red-400 text-xs mt-3">{t('newsletter_error')}</p>
        )}
      </div>
    </section>
  );
};

export default NewsletterSection;
